/**
 * utility functions to dispatch an event given an eventName and event's data
 * @param {string} eventName
 * @param {string|number|[number]} data
 */
const trackingEventDataDispatcher = (fieldName, eventName, placementId, data) => {
    const event = new CustomEvent(eventName, {
        detail: {
            fieldName,
            placementId,
            data
        },
    });
    document.dispatchEvent(event);
};

/**
 * Listens to a specific event and store the value of response in window.ebay.ads.tracking global object
 * ex:
 * window.ebay.ads.tracking = [{
 *      'ebay-ads-tracking-cache-hit-url-event-100571': "https://napkin.com/v1/example"
 * }]
 * @param {string} eventName
 */
const trackingEventDataListener = (eventName) => {
    if (document && window && window.ebay && window.ebay.ads && window.ebay.ads.tracking) {
        document.addEventListener(eventName, (e) => {
            const { placementId, fieldName, data } = e.detail;
            if (!window.ebay.ads.tracking[placementId]) {
                window.ebay.ads.tracking[placementId] = {};
            }
            window.ebay.ads.tracking[placementId][fieldName] = data;
        },
        { once: true });
    }
};

module.exports = {
    trackingEventDataDispatcher,
    trackingEventDataListener
};
